import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // <-- Agregado aquí

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Registra el service worker para activar modo PWA
serviceWorkerRegistration.register();